import React, { useRef, useState, useEffect } from 'react';
import marketingService from '../../../services/api/marketingService';

const SUGGESTIONS = [
  'Who reached checkout in the last 14 days but was never emailed?',
  'Show me everyone who opened an email but hasn’t paid',
  'How many leads came from Google Ads, and how many of those paid?',
  'Who gave "price" as their feedback reason?',
  'Which leads went quiet 30 to 60 days ago?',
];

function Assistant() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, busy]);

  const ask = async (question) => {
    const q = (question || input).trim();
    if (!q || busy) return;
    setError(null);
    setInput('');
    const nextMessages = [...messages, { role: 'user', content: q }];
    setMessages(nextMessages);
    setBusy(true);
    try {
      const result = await marketingService.askAssistant(nextMessages);
      setMessages([...nextMessages, { role: 'assistant', content: result.reply }]);
    } catch (err) {
      setError(err.message || 'Assistant request failed');
      setMessages(messages); // roll back the optimistic user message
      setInput(q);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mkt-feedback mkt-assistant">
      <div className="mkt-funnel-header">
        <h2>Ask AI</h2>
        {messages.length > 0 && (
          <button className="mkt-btn mkt-btn-secondary" onClick={() => setMessages([])}>
            New conversation
          </button>
        )}
      </div>
      <p className="mkt-feedback-note">
        Read-only access to the marketing data (leads, funnel steps, outreach, opens, feedback).
        It looks things up live and can&apos;t change or send anything.
      </p>

      <div className="mkt-assistant-thread">
        {messages.length === 0 && (
          <div className="mkt-assistant-suggestions">
            <p>Try asking:</p>
            {SUGGESTIONS.map((s) => (
              <button key={s} className="mkt-assistant-suggestion" onClick={() => ask(s)}>
                {s}
              </button>
            ))}
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`mkt-assistant-msg ${m.role}`}>
            <div className="mkt-assistant-bubble">{m.content}</div>
          </div>
        ))}
        {busy && (
          <div className="mkt-assistant-msg assistant">
            <div className="mkt-assistant-bubble mkt-assistant-thinking">Looking that up…</div>
          </div>
        )}
        {error && (
          <div className="mkt-assistant-msg assistant">
            <div className="mkt-assistant-bubble" style={{ color: '#dc2626' }}>{error}</div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <form
        className="mkt-assistant-composer"
        onSubmit={(e) => {
          e.preventDefault();
          ask();
        }}
      >
        <input
          type="text"
          className="mkt-search-input"
          placeholder="Ask about your leads, funnel, emails, feedback…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          disabled={busy}
        />
        <button type="submit" className="mkt-btn mkt-btn-primary" disabled={busy || !input.trim()}>
          {busy ? '…' : 'Ask'}
        </button>
      </form>
    </div>
  );
}

export default Assistant;
